const cards = [
  {
    title: '热播电视剧',
    subtitle: '每日同步追更',
    desc: '涵盖国产剧、韩剧、美剧、日剧等各类型热门电视剧全集，高清完整版一网打尽。',
    tag: '热门',
    icon: 'ri-tv-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20television%20series%20scene%20with%20warm%20moody%20lighting%2C%20emotional%20actors%20in%20modern%20setting%2C%20cinematic%20composition%2C%20dark%20rich%20color%20palette%2C%20professional%20film%20photography%2C%20warm%20amber%20tones%2C%20dramatic%20shadow%20play&width=640&height=400&seq=card-tv-drama&orientation=landscape',
  },
  {
    title: '最新电影',
    subtitle: '院线大片速递',
    desc: '国内外最新上映电影大全，动作、悬疑、喜剧、科幻等类型覆盖，高清画质沉浸观影。',
    tag: '新片',
    icon: 'ri-film-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20scene%20with%20dramatic%20landscape%20and%20warm%20golden%20hour%20lighting%2C%20professional%20film%20photography%2C%20rich%20dark%20shadows%2C%20atmospheric%20composition%2C%20warm%20coral%20and%20amber%20accents&width=640&height=400&seq=card-new-movies&orientation=landscape',
  },
  {
    title: '人气综艺',
    subtitle: '爆笑不断放送',
    desc: '热门综艺节目合集，真人秀、脱口秀、音乐竞演、旅行综艺等海量内容持续更新。',
    tag: '热播',
    icon: 'ri-emotion-happy-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20stage%20with%20colorful%20dynamic%20lighting%2C%20entertaining%20performance%20atmosphere%2C%20dark%20audience%20background%2C%20professional%20broadcast%20production%2C%20warm%20coral%20spotlights%2C%20energetic%20composition&width=640&height=400&seq=card-variety&orientation=landscape',
  },
  {
    title: '动漫番剧',
    subtitle: '二次元全收录',
    desc: '日漫、国漫、欧美动画等精品番剧大全，热门连载同步更新，经典重温随时观看。',
    tag: '推荐',
    icon: 'ri-ghost-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20illustration%20style%20scene%20with%20vibrant%20colors%2C%20dynamic%20character%20composition%2C%20fantasy%20world%20background%2C%20warm%20emotional%20lighting%2C%20modern%20animation%20aesthetic%2C%20rich%20detailed%20environment&width=640&height=400&seq=card-anime&orientation=landscape',
  },
  {
    title: '纪录片',
    subtitle: '探索真实世界',
    desc: '自然、历史、科技、人文等优质纪录片，高清影像呈现世界的震撼与美好。',
    tag: '精选',
    icon: 'ri-earth-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20dramatic%20landscape%2C%20warm%20sunlight%20through%20mountains%2C%20professional%20wildlife%20photography%2C%20rich%20earthy%20tones%2C%20cinematic%20wide%20angle%2C%20atmospheric%20depth&width=640&height=400&seq=card-documentary&orientation=landscape',
  },
  {
    title: '儿童频道',
    subtitle: '益智启蒙乐园',
    desc: '精选优质儿童动画、教育节目，安全健康的内容环境，陪伴孩子快乐成长。',
    tag: '亲子',
    icon: 'ri-heart-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20playful%20children%20animation%20scene%20with%20soft%20warm%20lighting%2C%20friendly%20characters%20in%20magical%20setting%2C%20gentle%20pastel%20colors%2C%20educational%20atmosphere%2C%20safe%20and%20cozy%20environment%2C%20storytelling%20composition&width=640&height=400&seq=card-kids&orientation=landscape',
  },
  {
    title: '经典老片',
    subtitle: '时光珍藏馆',
    desc: '跨越时代的经典影视作品，从黑白默片到千禧佳作，重温光影艺术的永恒魅力。',
    tag: '经典',
    icon: 'ri-time-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20vintage%20film%20aesthetic%20with%20old%20Hollywood%20glamour%2C%20black%20and%20white%20cinematic%20composition%2C%20dramatic%20lighting%20with%20warm%20sepia%20tones%2C%20nostalgic%20movie%20theater%20atmosphere%2C%20timeless%20elegant%20photography&width=640&height=400&seq=card-classic&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            内容分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            海量影视 · 随心观看
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2 max-w-xl mx-auto">
            七大类目覆盖全网影视资源，高清画质流畅播放，满足您的一切观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {cards.map((card, idx) => (
            <article
              key={card.title}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.imageUrl}
                  alt={`黄瓜影院${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 3 ? 'lazy' : undefined}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-500/10">
                    <i className={`${card.icon} text-sm text-accent-400`}></i>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-900">{card.title}</h3>
                </div>
                <p className="text-xs text-primary-400 font-medium mb-2">{card.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}